import CssBaseline from '@mui/material/CssBaseline';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import StyledEngineProvider from '@mui/styled-engine/StyledEngineProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import PropTypes from 'prop-types';
import React from 'react';
import fingoTheme from '../theme';

const MuiProvider = ({ children, theme }) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {children}
      </LocalizationProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);

MuiProvider.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.shape({
    palette: PropTypes.shape({}),
    breakpoints: PropTypes.shape({}),
    typography: PropTypes.shape({}),
    components: PropTypes.shape({}),
  }),
};

MuiProvider.defaultProps = {
  theme: fingoTheme,
};

export default MuiProvider;
